import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/app.materials';
import { DndDirective } from 'src/app/shared/directives/dnd.directive';

@Component({
  selector: 'app-portfolio-upload-dialog',
  templateUrl: './portfolio-upload-dialog.component.html',
  styleUrls: ['./portfolio-upload-dialog.component.scss'],
  standalone: true,
  imports: [MaterialModule, DndDirective],
})
export class PortfolioUploadDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PortfolioUploadDialogComponent, File>,
  ) {}

  onFileDropped(files: FileList): void {
    this.emitFirst(files);
  }

  onFileBrowse(input: HTMLInputElement): void {
    this.emitFirst(input.files);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  private emitFirst(files: FileList | null): void {
    if (files && files.length) {
      this.dialogRef.close(files[0]);
    }
  }
}
